var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQualityRibbon = function SvgQualityRibbon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 124,
    viewBox: "0 0 85 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "quality",
    clipPath: "url(#clip0_3818_241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42.5 85.4961C19.0504 85.4961 0 66.4753 0 43.0621C0 19.649 19.0504 0.628174 42.5 0.628174C65.9496 0.628174 85 19.649 85 43.0621C85 66.4753 65.9496 85.4961 42.5 85.4961ZM42.5 4.44761C21.1926 4.44761 3.82538 21.7879 3.82538 43.0621C3.82538 64.3364 21.1926 81.6767 42.5 81.6767C63.8074 81.6767 81.1746 64.3364 81.1746 43.0621C81.1746 21.7879 63.8074 4.44761 42.5 4.44761Z",
    fill: "#10A2FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M67.2502 123.309L42.5 112.767L17.7498 123.309V76.1768H21.5751V117.541L42.5 108.604L63.4248 117.541V76.1768H67.2502V123.309Z",
    fill: "#10A2FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42.5 74.8399C24.9415 74.8399 10.6729 60.5934 10.6729 43.0622C10.6729 25.5309 24.9415 11.2844 42.5 11.2844C60.0585 11.2844 74.3272 25.5309 74.3272 43.0622C74.3272 60.5934 60.0585 74.8399 42.5 74.8399ZM42.5 15.1039C27.0455 15.1039 14.4982 27.6316 14.4982 43.0622C14.4982 58.4927 27.0455 71.0205 42.5 71.0205C57.9546 71.0205 70.5018 58.4927 70.5018 43.0622C70.5018 27.6316 57.9546 15.1039 42.5 15.1039Z",
    fill: "#10A2FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M52.5226 58.0725L42.5001 52.8017L32.4393 58.0725L34.352 46.9197L26.2422 39.0135L37.4506 37.3711L42.4618 27.2114L47.4731 37.3711L58.7197 39.0135L50.6099 46.9197L52.5226 58.0725ZM42.5001 48.4857L47.4731 51.0829L46.5167 45.5447L50.5334 41.6489L44.9866 40.8468L42.5001 35.8434L40.0136 40.8468L34.4668 41.6489L38.4834 45.5447L37.5271 51.0447L42.5001 48.4475V48.4857Z",
    fill: "#10A2FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M44.4128 83.5864H40.5874V110.666H44.4128V83.5864Z",
    fill: "#10A2FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3818_241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 122.68,
    fill: "white",
    transform: "translate(0 0.628174)"
  })))));
};
export default SvgQualityRibbon;